import React, { useState } from 'react'
import { CancelButton, SaveButton } from '../EmailPopup/EmailPopup'
import { useTranslation } from 'react-i18next'
import { Trans } from 'react-i18next';
import image from '../../../assets/RectangleImage.png'

import {
WearableButtonContainer,
WearableContaianer,
WearableContent,
WearableHead,
WearableLabel,
IceExchange,
SelectedInfo,
LastSelectedInfo,
LastWearableLabel,
RentInfo,
TestSpan,
WearableCaption,
WearableImage,
WearableImageContainer,
WearableText1,
WearableText2,
WearableTextContainer
} from './wearableStyles'








const WearablePopup = ({display, Cancel}) => {
  const { t } = useTranslation()

  const [numberOfICE, setNumberofICE] = useState(100);
  const [numberOfRecieve, setNumberOfRecieve] = useState((numberOfICE * 96) / 100);
  const [nameOfWearable, setNameOfWearable] = useState('Bomber Pants');
  

    
  return (
    <>
    <WearableContaianer display= {display}>
        <WearableHead>{t("page16.popUp.caption")}</WearableHead>
        <WearableCaption>
            <WearableImageContainer>
                <WearableImage src={image} />
            </WearableImageContainer>
            <WearableTextContainer>
                <WearableText1>Bomber Pants</WearableText1>
                <WearableText2>2 Levels. 25% Multiplier</WearableText2>
            </WearableTextContainer>
        </WearableCaption>
        <IceExchange> 1 ICE = 0.0001 USD</IceExchange>
        <WearableContent>
            <WearableLabel>Price 50 Ice Min <SelectedInfo> 100 ICE/Day</SelectedInfo></WearableLabel>
            <WearableLabel>Term <SelectedInfo> 60 Days</SelectedInfo></WearableLabel>
            <WearableLabel>Start Date <SelectedInfo> Feburary 1st, 2022</SelectedInfo></WearableLabel>
            <LastWearableLabel>Expected End Date <LastSelectedInfo> May 1st, 2021</LastSelectedInfo></LastWearableLabel>
        </WearableContent>
         <RentInfo>
            <Trans i18nKey='page16.popUp.rentInfo'>
            "You've set 
            <TestSpan>{{numberOfICE}}</TestSpan> 
            as the rental price of 
            {{nameOfWearable}}
            .Since there's a proceessing fee of 4%, you'll recieve  {{numberOfRecieve}}  ICE  per day for this transaction "
            </Trans>
        </RentInfo> 
        <WearableButtonContainer>
            <CancelButton onClick={Cancel}>{t("page5.emailPopup.cancel")}</CancelButton>
            <SaveButton>{t("page5.rentMeButton")}</SaveButton>
        </WearableButtonContainer>

    </WearableContaianer>
    </>
  )
}

export default WearablePopup